import React, {Component} from 'react';
import {connect} from "react-redux";
import {Trans} from 'react-i18next';
import {withRouter} from "react-router-dom";
import { withTranslation } from 'react-i18next';
import {putDeleteLabel} from "../../../../../../../actions/contactsGroupItemActions";
import Button from "../../../../../../components/button";
import {getSharingDetailsPopup} from "../../../../../../../actions/sharingDetailsActions";
import Icon from "../../../../../../components/icon";


class LabelDeleteConfirmPopup extends Component {

    constructor(props){
        super(props);

        this.state = {
            isLabelDeletionProcessing: false
        };

        this.proceed = this.proceed.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }



    proceed(){
        this.setState({
            isLabelDeletionProcessing: true
        }, () => {
            this.props.putDeleteLabel(this.props.sharingDetailsPopup[2].labelId, this.props.sharingDetailsPopup[2].labelName);
        });
    }

    handleCancel(){
        this.props.getSharingDetailsPopup([]);
    }

    render() {
        return (
            <div className="p-3">
                <h2 className="my-2">{this.props.t("deleteLabel")}</h2>
                <Trans i18nKey="confirmDeleteText" values={{labelName: this.props.sharingDetailsPopup[2].labelName}}/>
                <div className="text-right">
                    {
                        this.state.isLabelDeletionProcessing
                        ?
                            <Button disabled={true} className="btn-primary">
                                <Icon animated={'pulse'} name="spinner"/>
                            </Button>
                        :
                            <React.Fragment>
                                <Button className="btn-primary" onClick={this.proceed}> {this.props.t("yesText")}</Button>
                                <Button className="btn-outline-primary ml-3" onClick={this.handleCancel}>{this.props.t("noText")}</Button>
                            </React.Fragment>
                    }
                </div>

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    putDeleteLabel: (labelId, labelName) => {
        dispatch(putDeleteLabel(labelId, labelName, ownProps))
    },
    getSharingDetailsPopup: (array) => {
        dispatch(getSharingDetailsPopup(array))
    },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LabelDeleteConfirmPopup)));
